import React, { Component } from "react";

import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";

import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import {withRouter} from 'react-router-dom'
import axios from "axios";

/**
 * UpdateDocumentDetail Component for updating the Document details.
 */
class UpdateDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      candidateQualification:"",
      showFiles: "",
      file: [],
      message: "",
      error:"",
      err: "",
      fileError:"",
      getDocumentData:[]
    };

 
    this.fileselecting = this.fileselecting.bind(this);
    this.updateDocument = this.updateDocument.bind(this);
    this.fetchDocument = this.fetchDocument.bind(this)
  }

  componentDidMount() {
    
    this.fetchDocument()
  
  }

  // fetch document list from rs
  fetchDocument(){
    axios
      .get(`${RS_API}/v1/api/can-upload-document/can`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
            getDocumentData: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // onchange function for selecting file
  fileselecting(e) {
    console.log(e.target.files[0]);
    let allowedExtension = /(\.pdf)$/i;
    if (allowedExtension.exec(e.target.files[0].name)) {
      if ((e.target.files[0].size / 1024 / 1024).toFixed(2) < 2) {
        this.setState({
          file: e.target.files[0] || [],
          fileError: "",
        });


      } else {
        this.setState({
          file: e.target.files[0],
          fileError: "File size must less than 2MB",
        });
      }
    } else {
      this.setState({
        file: e.target.files[0],
        fileError: "Please attach PDF document",
      });
    }

   
  }

  // update function by clicking update button
  updateDocument() {
    if (!this.state.candidateQualification) {
      this.setState({
        err: "Please select document name",
      });
    } else {
      this.setState({
        err: "",
      });
    }

    let edit = this.state.candidateQualification;
    let body = this.state.file;
    console.log(edit);
    const data = new FormData();
    data.append("name", "Image Upload");
    data.append("file", body);
    data.append("documentName",this.state.candidateQualification)
 
      axios
        .post(
          `${API_CANDIDATE}/v1/api/upload-document`,
          data,
          { withCredentials: true },
          {
            headers: {
              "Content-Type": "multipart/form-data; ",
            },
          }
        )
        .then((res) => {
          if (res.data.ok && !this.state.fileError) {
            this.setState({
              message: "Uploaded successfully",
            });
            setTimeout(() => {
              this.setState({
                message: "",
              });
              this.props.back();
            }, 2000);
          }
          else {
            this.setState({
              error: "Enter all mandatory fields",
            });
            setTimeout(() => {
              this.setState({
                error: "",
              });
            }, 2000);
          
          }

          console.log(res);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    
  }

  render() {
 

    return (
      <>
        <div style={{ paddingLeft: "2.5rem" }}>
          <i
            className="material-icons cancel-button pointer"
            onClick={this.props.back}
          >
            cancel
          </i>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                fontSize: "24px",
                fontWeight: "bold",
                paddingTop: "0.5rem",
              }}
            >
              <span>Upload Documents</span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "8px",
                }}
              >
                <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                  Document Name
                </span>
                <select
                  style={{
                    height: "40px",
                    marginTop: "10px",
                    outline: "none",
                    borderColor: "grey",
                    width: "600px",
                    fontSize: "20px",
                  }}
                  value={this.state.candidateQualification}
                  required={true}
                  onChange={(e) =>
                    this.setState({
                      candidateQualification: e.target.value,
                      err: "",
                    })
                  }
                >
                   <option value="" hidden>
                                Select...
                              </option>
                              {this.state.getDocumentData.map((item) => {
                                return (
                                  <option
                                    key={item.id}
                                    value={item.documentName}
                                  >
                                    {item.documentName}
                                  </option>
                                );
                              })}
                </select>
                <span style={{ fontSize: 15, color: "red" }}>
                  {this.state.err ? this.state.err : ""}
                </span>
              </div>

              <div
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "40px",
                    marginTop: "5px",
                    width: "480px",
                    background: "#DCDCDC",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span>{this.state.file.name || ""}</span>
                </div>

                <span
                  style={{ marginLeft: "2rem" }}
                  className="btn btn-primary btn-file"
                >
                  Browse...
                  <input type="file" onChange={this.fileselecting} />
                </span>
              </div>
              {this.state.fileError && (
                    <span style={{fontSize: 15, color: "red"}} className="error ">
                      
                      {this.state.fileError}
                    </span>
                  )}

              <span style={{ fontSize: "14px" }}>Supported format(pdf)</span>

              <div className="center" style={{ paddingBottom: "2rem" }}>
                <Button
                  type="submit"
                  onClick={this.updateDocument}
                  style={{
                    background: "green",
                    marginTop: "30px",
                    color: "white",
                  }}
                  className="btn login-button white-text"
                >
                  Upload
                </Button>
              </div>
              {this.state.message && <Notifier message={this.state.message} />}
              {this.state.error && <ErrorNotifier message={this.state.error} />}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default  withRouter(UpdateDocument)

// const mapStateToProps = (state) => ({
//   profile: state.profile,
// });

// export default connect(mapStateToProps,{getProfileInfo})(
//   withRouter(UpdateDocument)
// );